import { Button, Space } from 'antd';
import { FC, ReactElement, memo } from 'react';
import { PlusCircle, Stack } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

import { useAppPagination } from '@/common/hooks';
import { AppRoutes } from '@/common/interfaces';
import { CommonContainerTitle, FallbackedLayout } from '@/common/layouts';

import { useGetAllRedirectsQuery } from '@/modules/Sites';

import { RedirectsConflictsContainer } from '../RedirectsConflicts';
import { RedirectsListView } from './RedirectsListView';

interface Props {
  siteId: string;
}

export const RedirectsListContainer: FC<Props> = memo(({ siteId }) => {
  const { pageParam: currentPage, handleChangePage } = useAppPagination();

  const {
    data: redirectsListData,
    error: redirectsListError,
    isLoading: isRedirectsListLoading,
    isFetching: isRedirectsListFetching,
    isError: isRedirectsListError
  } = useGetAllRedirectsQuery(siteId, { page: currentPage })();

  return (
    <FallbackedLayout
      isLoading={ isRedirectsListLoading }
      error={ redirectsListError }
      isError={ isRedirectsListError }
      data={ redirectsListData }
    >
      { (redirectsList): ReactElement => (
        <>
          <CommonContainerTitle
            onlyExtra
            extra={
              <Space>
                <RedirectsConflictsContainer siteId={ siteId }/>

                <Link to={ AppRoutes.RedirectsBulk.replace(':siteId', siteId) }>
                  <Button icon={ <Stack/> }>
                    Масові операції
                  </Button>
                </Link>

                <Link to={ AppRoutes.RedirectsCreate.replace(':siteId', siteId) }>
                  <Button icon={ <PlusCircle/> } type="primary">
                    Створити редірект
                  </Button>
                </Link>
              </Space>
            }
          />

          <RedirectsListView
            siteId={ siteId }
            currentPage={ currentPage }
            redirectsListItems={ redirectsList.items }
            redirectsListTotalItems={ redirectsList.meta.totalItems }
            redirectsListItemsPerPage={ redirectsList.meta.itemsPerPage }
            isLoading={ isRedirectsListFetching }
            handleChangePage={ handleChangePage }
          />
        </>
      ) }
    </FallbackedLayout>
  );
});
